import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=7ca01740&scoped=true&"
import script from "./GeneralSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&id=7ca01740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca01740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca01740')) {
      api.createRecord('7ca01740', component.options)
    } else {
      api.reload('7ca01740', component.options)
    }
    module.hot.accept("./GeneralSettings.vue?vue&type=template&id=7ca01740&scoped=true&", function () {
      api.rerender('7ca01740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/GeneralSettings.vue"
export default component.exports